var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-text",class:{ uppercase: _vm.uppercase }},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("camdo"),_c('strong',[_vm._v("nhanh")])])}]

export { render, staticRenderFns }